import { useCallback, useLayoutEffect, useRef } from 'react'

const STATIC_DEPS = []

/**
 * This is proposal: https://github.com/reactjs/rfcs/pull/220
 *
 * See also: https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md
 *
 * Example to use:
 * ```tsx
 * function Foo() {
 *   const [text, setText] = useState('');
 *
 *   const handleClick = useEvent(() => {
 *       sendMessage(text);
 *   });
 *
 *   // SendButton has memo HOC wrapper
 *   return <SendButton onClick={handleClick} />;
 * }
 * ```
 */
export function useEvent(handler) {
    const handlerRef = useRef(handler)

    useLayoutEffect(() => {
        handlerRef.current = handler
    })

    return useCallback((...args) => {
        const fn = handlerRef.current
        return fn(...args)
    }, STATIC_DEPS)
}



// WEBPACK FOOTER //
// ./hooks/useEvent.js